<template>
  <div class="flex q-gutter-x-sm no-wrap" v-if="error">
    <q-icon
        :name="ICONS.exclamationTriangle"
        color="red"
        v-if="icon"
        size="10px"
        class="q-mt-xs"
    />
    <div class="s-font-2xs text-red-7 q-mr-auto">
      {{ error?.message }}
    </div>
    <slot
        v-if="$slots.side"
        name="side"
    />
  </div>
</template>

<script lang="ts" setup>

import {VorderError} from "@/gql/gen";
import {ICONS} from "@/assets/icons";

const props = withDefaults(defineProps<{
  error: VorderError | null | undefined,
  icon?: boolean
}>(), {})

</script>

<style scoped>

</style>
